import React from 'react';

const LandingPage = () =>
  <div>
    <section className="theme-dark hero">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <span className="headline">General Data Protection Regulation</span>
            <h1>GDPR is Coming. Are You Ready?</h1>
            <span className="subtitle">Take our GDPR Readiness Assessment to find out.</span>
            <div className="cta-action">
              <a className="btn btn-lg btn-success" href="/gdpr-assessment/tool-1">
                Start the survey
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="content">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <img src="https://cdn.auth0.com/website/assets/pages/gdpr-assessment-tool/assets/eu-flag-4b8890fae3.svg" alt="EU Flag" />
          </div>
          <div className="col-md-offset-1 col-md-7">
            <p>
              The GDPR Readiness Assessment*, by Auth0 and Cordery Compliance, is one way to prepare
              for the new regulation that will be enforced on May 25, 2018. Completing this
              questionnaire will measure your level of readiness, along with recommendations for
              your key areas of focus.
            </p>
            <p>
              (*The GDPR Readiness Assessment does not create a lawyer-client relationship. Always
              seek the advice of competent counsel. Our website Terms and Conditions are here, and
              our Privacy Policy is here.)
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>;

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/LandingPage/LandingPage.js